module.exports = __webpack_public_path__ + "img/curve-home-middle.aabe1bb8.png";